import Modules from '@app/modules';
Modules.register({
    namespace: 'Racerfish/Evolve'
});
